import React from 'react'

const Data = () => {
    return (
        <div className="home__data">
            <h1 className="home__title">
                Krafox
            </h1>

            <h3 className='home__subtitle'>Desarrollamos tus ideas</h3>

            {/* <a href="#contact" className='button button--flex'>
                Conversemos
            </a> */}
        </div>
    )
}

export default Data
